// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__62WNE","media":"style_media__Uv0Fo","main_price":"style_main_price__0rczX","main_btn":"style_main_btn__D+ivi"};